// Wall-list mutations — create / delete / set-active / set-property.
// The waypoint-level mutations (add / move / delete / sharp toggle)
// already work on walls via activeWaypoints(state) routing to the
// active wall's waypoint array.

import { clearSelection } from './state.js';
import { pushHistory } from './history.js';

export function createWall(state, notify) {
  if (!Array.isArray(state.trackData.walls)) state.trackData.walls = [];
  state.trackData.walls.push({
    waypoints: [],
    closed: true,
    thickness: 0.5,
    alpha: 0.5,
  });
  state.activeWallIdx = state.trackData.walls.length - 1;
  clearSelection(state);
  pushHistory(state, notify);
}

export function deleteWall(state, idx, notify) {
  const walls = state.trackData.walls;
  if (!walls || idx < 0 || idx >= walls.length) return;
  walls.splice(idx, 1);
  if (state.activeWallIdx === idx)       state.activeWallIdx = -1;
  else if (state.activeWallIdx > idx)    state.activeWallIdx -= 1;
  clearSelection(state);
  pushHistory(state, notify);
}

export function setActiveWall(state, idx, notify) {
  if (idx === state.activeWallIdx) return;
  state.activeWallIdx = idx;
  clearSelection(state);
  notify();
}

// Patch a single property on the active wall (thickness / alpha /
// closed). Caller chooses live (input) vs commit (change) by passing
// either applyChangeLive or applyChange semantics on top.
export function updateActiveWall(state, patch) {
  const w = state.trackData.walls?.[state.activeWallIdx];
  if (!w) return;
  Object.assign(w, patch);
}
